const VerbEnum = {
  VIEW: 'view',
  CLICK: 'click',
};

export default VerbEnum;
